<script lang="ts">
  import { router } from '../router.svelte';
  import { nest } from '../nest.svelte';
  import { humanize } from '../../shared/slug.js';

  let { slug, onclose }: { slug: string; onclose: () => void } = $props();

  const page = $derived(nest.get(slug));

  function open() {
    const to = slug;
    onclose();
    router.go(`/page/${to}`);
  }
</script>

<button class="scrim" onclick={onclose} aria-label="Dismiss"></button>
<div class="sheet" role="dialog" aria-modal="true">
  {#if page}
    <span class="chip">{page.type}</span>
    <h3>{humanize(page.slug)}</h3>
    {#if page.summary}<p>{page.summary}</p>{/if}
    <button class="open" onclick={open}>Open page →</button>
  {:else}
    <h3>{humanize(slug)}</h3>
    <p>No page by this name in your nest yet.</p>
  {/if}
</div>

<style>
  .scrim {
    position: fixed;
    inset: 0;
    z-index: 60;
    background: rgba(34, 22, 4, 0.32);
    border: none;
  }
  .sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 61;
    background: var(--cream);
    border-top: 1px solid var(--line);
    border-radius: 18px 18px 0 0;
    padding: 20px 20px calc(24px + env(safe-area-inset-bottom));
    box-shadow: var(--shadow-lift);
    max-width: var(--content-max);
    margin: 0 auto;
  }
  .chip {
    font-family: var(--mono);
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 2px 7px;
    border-radius: 999px;
    background: var(--paper);
    color: var(--ink-soft);
  }
  h3 {
    font-family: var(--serif);
    font-size: 20px;
    margin: 8px 0;
  }
  p {
    color: var(--ink-soft);
    font-size: 14px;
    line-height: 1.5;
  }
  .open {
    margin-top: 16px;
    border-radius: 12px;
    padding: 11px 18px;
    background: var(--rooster);
    color: var(--cream);
    font-family: var(--mono);
    font-weight: 700;
    font-size: 12px;
  }
  @media (min-width: 900px) {
    .sheet {
      left: 84px;
    }
  }
</style>
